export default "__VITE_ASSET__Bw$EJNN$__"